/**
 * Importing the styles here.
 */

import './static/styles/main.scss';
